import script from "./PreviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewPage.vue?vue&type=script&setup=true&lang=js"

import "./PreviewPage.vue?vue&type=style&index=0&id=496d0e94&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-496d0e94"]])

export default __exports__